import { useCallback, useEffect, useRef, useState } from 'react'

import { focusFirstInvalid, invalidFieldSelector } from '@/shared/ui/invalid-field'

export { invalidFieldSelector }

/**
 * For a form that saves outside `RecordForm` and outside a `Dialog`, whose actions do this
 * themselves: after a refused save, `reveal()` focuses the first field in error inside `ref`, once
 * its error has rendered.
 */
export function useFocusFirstInvalid<T extends HTMLElement>() {
  const ref = useRef<T>(null)
  const [revealed, setRevealed] = useState(0)
  useEffect(() => {
    if (revealed > 0 && ref.current !== null) {
      focusFirstInvalid(ref.current)
    }
  }, [revealed])
  const reveal = useCallback(() => setRevealed((count) => count + 1), [])
  return { ref, reveal }
}
